import {enableProdMode} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';

import {AppModule} from './app/app.module';
import {environment} from './environments/environment';

if (environment.production) {
  enableProdMode();
  // disables console.log() in production
  window.console.log = () => { }
}

platformBrowserDynamic().bootstrapModule(AppModule).then(ref => {
}).catch(err => console.log(err));
